var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundLocationFilled24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "3.2692307692309726 4.638846153846387 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.27 4.64L27.27 28.64L3.27 28.64L3.27 4.64L27.27 4.64Z",
    id: "a3TOZK9gct"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.48 7.26L18.49 7.68L19.41 8.25L20.22 8.95L20.92 9.77L21.49 10.69L21.91 11.69L22.18 12.77L22.27 13.9L22.14 15.2L21.8 16.55L21.27 17.94L20.6 19.34L19.83 20.7L19.01 22.01L18.18 23.22L17.38 24.31L16.65 25.26L16.04 26.01L15.91 26.14L15.76 26.24L15.61 26.32L15.44 26.36L15.27 26.37L15.11 26.36L14.94 26.32L14.78 26.24L14.64 26.14L14.51 26.01L13.89 25.26L13.16 24.31L12.36 23.22L11.53 22.01L10.71 20.7L9.94 19.34L9.27 17.94L8.74 16.55L8.39 15.2L8.27 13.9L8.36 12.77L8.63 11.69L9.05 10.69L9.62 9.77L10.32 8.95L11.13 8.25L12.05 7.68L13.06 7.26L14.13 7L15.27 6.9L16.41 7L17.48 7.26ZM13.5 12.14L12.97 12.93L12.77 13.9L12.97 14.88L13.5 15.67L14.3 16.21L15.27 16.4L16.24 16.21L17.04 15.67L17.57 14.88L17.77 13.9L17.57 12.93L17.04 12.14L16.24 11.6L15.27 11.4L14.3 11.6L13.5 12.14Z",
    id: "c2UMOb8f0O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.14 13.76C18.14 15.35 16.86 16.64 15.27 16.64C13.68 16.64 12.39 15.35 12.39 13.76C12.39 12.18 13.68 10.89 15.27 10.89C16.86 10.89 18.14 12.18 18.14 13.76Z",
    id: "a6KhwtTW9k"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3TOZK9gct",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3TOZK9gct",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2UMOb8f0O",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2UMOb8f0O",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6KhwtTW9k",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundLocationFilled24Px);
export default __webpack_public_path__ + "static/media/round-location_filled-24px.54ff0e4c32b2fb113456aace970d7624.svg";
export { ForwardRef as ReactComponent };